// extracted by mini-css-extract-plugin
module.exports = {"container":"loadingspinner_container__ho69R","containerBg":"loadingspinner_containerBg__10Pui","box":"loadingspinner_box__2x1Kb","spinner":"loadingspinner_spinner__1KqJX"};